/**
 * Behörighetstyper för byggföretag
 * Används för att visa rätt namn, beskrivning och logotyp
 *
 * Logotyp finns bara för Säker Vatten och Elsäkerhetsverket — de som
 * redovisas som registerlänk. Övriga laddas upp som PDF och visas med den
 * färgade rutan. Sätt inte en logo-sökväg utan att filen ligger i
 * public/images/certifications: varje saknad fil ger en 404 i konsolen.
 * Samma urval i backend/src/utils/behorighetssida.js.
 */

export const CERTIFICATION_TYPES = {
  sakervatten: {
    id: 'sakervatten',
    name: 'SäkerVatten',
    shortName: 'SäkerVatten',
    description: 'Auktoriserad VVS-installatör enligt Säker Vatten',
    logo: '/images/certifications/sakervatten.png',
    color: '#0066B3',
    website: 'https://www.sakervatten.se'
  },
  bkr: {
    id: 'bkr',
    name: 'BKR',
    shortName: 'BKR',
    description: 'Byggkeramikrådet - auktoriserad plattsättare',
    logo: null,
    color: '#E31E24',
    website: 'https://www.bfrw.se'
  },
  gvk: {
    id: 'gvk',
    name: 'GVK',
    shortName: 'GVK',
    description: 'Golvbranschens Våtrumskontroll - auktoriserad våtrumsinstallatör',
    logo: null,
    color: '#00A651',
    website: 'https://www.gfrw.se'
  },
  'bas-p': {
    id: 'bas-p',
    name: 'BAS-P',
    shortName: 'BAS-P',
    description: 'Byggarbetsmiljösamordnare för planering och projektering',
    logo: null,
    color: '#FFB81C',
    website: null
  },
  'bas-u': {
    id: 'bas-u',
    name: 'BAS-U',
    shortName: 'BAS-U',
    description: 'Byggarbetsmiljösamordnare för utförande',
    logo: null,
    color: '#FF6B00',
    website: null
  },
  elsakerhetsverket: {
    id: 'elsakerhetsverket',
    name: 'Elsäkerhetsverket',
    shortName: 'El',
    description: 'Registrerad elinstallatör hos Elsäkerhetsverket',
    logo: '/images/certifications/elsakerhetsverket.png',
    color: '#FFC107',
    website: 'https://www.elsakerhetsverket.se'
  },
  forsakringsbolag: {
    id: 'forsakringsbolag',
    name: 'Försäkringsbolag',
    shortName: 'Försäkring',
    description: 'Allrisk- och ansvarsförsäkring',
    logo: null,
    color: '#2196F3',
    website: null
  },
  registerutdrag: {
    id: 'registerutdrag',
    name: 'Registerutdrag',
    shortName: 'Register',
    description: 'Registerutdrag från Bolagsverket eller liknande',
    logo: null,
    color: '#9C27B0',
    website: null
  },
  other: {
    id: 'other',
    name: 'Övrigt',
    shortName: 'Övrigt',
    description: 'Annan typ av behörighet eller certifiering',
    logo: null,
    color: '#757575',
    website: null
  }
};

// Lista för dropdown-val
export const CERTIFICATION_OPTIONS = Object.values(CERTIFICATION_TYPES).map(cert => ({
  value: cert.id,
  label: cert.name,
  description: cert.description
}));

// Hämta info för en specifik behörighetstyp
export const getCertificationInfo = (type) => {
  return CERTIFICATION_TYPES[type] || CERTIFICATION_TYPES.other;
};

export default CERTIFICATION_TYPES;
